import React, { useEffect, useMemo } from "react";
import { FilterOutlined } from "@ant-design/icons";
import Modal from "components/Modal/Modal";
import { Button } from "components/Buttons/Buttons";
import { FormRadioGroup, FormSelect } from "components/FormItems/FlatFormItems";
import { useSelector } from "react-redux";
import { CalenderOperationType } from "utils/enums";
import { Form } from "antd";
import { uniqBy } from "lodash";

export default function ChartFilter({ selectedNP, onSelectedNPChange }) {
  const [showFilter, setShowFilter] = React.useState(false);

  const { wholeStaff } = useSelector((state) => ({
    wholeStaff: state.user.wholeStaff,
  }));

  const { facilities, isFetchingFacilities } = useSelector((state) => {
    return {
      facilities: state.facilities.allFacilities,
      isFetchingFacilities: state.facilities.isFetchingFacilities,
    };
  });

  const [form] = Form.useForm();

  const nurseStaff = useMemo(() => {
    return wholeStaff?.filter((staff) => {
      return (
        staff.roleName === "Nurse" ||
        staff.roleName === "Nurse Practitioner" ||
        staff.roleName === "Nurse Lead" ||
        staff.roleName === "Admin"
      );
    });
  }, [wholeStaff]);

  const physicianStaff = useMemo(() => {
    return wholeStaff?.filter((staff) => {
      return (
        staff.roleName === "Nurse Practitioner" ||
        staff.roleName === "Physician"
      );
    });
  }, [wholeStaff]);

  const states = useMemo(() => {
    return uniqBy(facilities, "state")?.map((f) => ({
      stateId: f.stateId,
      stateName: f.state,
    }));
  }, [facilities]);

  useEffect(() => {
    if (showFilter) {
      form.setFieldsValue({
        stateId: selectedNP?.stateId ?? undefined,
        staffId: selectedNP?.staffId ?? undefined,
        physicianId: selectedNP?.physicianId ?? undefined,
        chartStatus: selectedNP?.chartStatus ?? undefined,
      });
    }
  }, [showFilter, selectedNP]);

  const hasFilterValue = useMemo(() => {
    return Object.keys(selectedNP).find(key => {
      if (typeof selectedNP[key] === 'object' && selectedNP?.[key]?.length > 0) {
        return true
      }
      else if (typeof selectedNP[key] !== 'object' && selectedNP[key] !== undefined && selectedNP[key] !== null)
        return true
      return false
    })
  }, [selectedNP])


  return (
    <>
      <button
        className={`calenderFilterBtn ${hasFilterValue ? "active" : ""}`}
        onClick={() => {
          setShowFilter(true);
        }}
        style={{borderRadius: 6}}
      >
        <FilterOutlined style={{ fontSize: 18 }} />
      </button>
      <Modal
        title="Filters"
        open={showFilter}
        // onOk={() => {}}
        onCancel={() => {
          setShowFilter(false);
        }}
        footer={[]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={(values) => {
            for (const key in values) {
              if (values[key] === undefined || values[key] === null) {
                delete values[key];
              }
            }

            if (Object.keys(values).length === 0) {
              onSelectedNPChange({
                stateId: undefined,
                staffId: undefined,
                physicianId: undefined,
                chartStatus: undefined,
              });
            } else {
              onSelectedNPChange(values);
            }
            setShowFilter(false);
          }}
          initialValues={{
            operationTypeId: CalenderOperationType.All,
          }}
          defaultValue={{
            operationTypeId: CalenderOperationType.All,
          }}
        >
          <FormSelect
            name="stateId"
            formItemStyles={{
              width: "100%",
            }}
            // mode="multiple"
            variant="underlined"
            label="State"
            placeholder="State"
            options={states}
            renderValue="stateId"
            renderLabel="stateName"
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase?.()
                .includes?.(input.toLowerCase());
            }}
            allowClear={true}
            showSearch={true}
          />

          <FormSelect
            name="staffId"
            formItemStyles={{
              width: "100%",
            }}
            variant="underlined"
            label="Nurse"
            placeholder="Nurse"
            options={nurseStaff}
            renderValue="staffId"
            renderLabel="name"
            optionLabelProp="label"
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase?.()
                .includes?.(input.toLowerCase());
            }}
            renderOption={(opt) => {
              return opt["name"];
            }}
            allowClear={true}
            showSearch={true}
          />

          <FormSelect
            name="physicianId"
            formItemStyles={{
              width: "100%",
            }}
            variant="underlined"
            label="NP/Physician"
            placeholder="NP/Physician"
            options={physicianStaff}
            renderValue="staffId"
            renderLabel="name"
            optionLabelProp="label"
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase?.()
                .includes?.(input.toLowerCase());
            }}
            renderOption={(opt) => {
              return opt["name"];
            }}
            allowClear={true}
            showSearch={true}
          />

          <FormSelect
            name="chartStatus"
            formItemStyles={{
              width: "100%",
            }}
            variant="underlined"
            label="Status"
            placeholder="Status"
            options={[
              { label: "Unassigned", value: 1 },
              { label: "Assigned", value: 2 },
              { label: "Pending", value: 3 },
              { label: "Completed", value: 4 },
            ]}
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase?.()
                .includes?.(input.toLowerCase());
            }}
            renderLabel={"label"}
            renderValue="value"
            allowClear={true}
            showSearch={true}
          />
          <div style={{ gap: 12, display: "flex" }}>
            <Button
              htmlType={"submit"}
              rounded={true}
              onClick={() => {
                // dispatch(setCurrentStaffIds([]));
                // onSelectedNPChange();
              }}
            >
              Submit
            </Button>
            <Button
              rounded={true}
              onClick={() => {
                // dispatch(setCurrentStaffIds([]));
                // onSelectedNPChange();
                form.resetFields();
              }}
            >
              Clear
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}
